(function () {
  var SALE_PILL_TEXT = '4th of July Sale';
  var FACES = [
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-customer2.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-customer3.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-adv-author-f.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-adv-author.png',
    'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-blog-author.png'
  ];

  function deAnim(el) {
    try {
      (el.getAnimations ? el.getAnimations({ subtree: true }) : []).forEach(function (a) {
        if (a.animationName && a.animationName.indexOf('rgx-') === 0) return;
        a.cancel();
      });
    } catch (e) {}
  }
  function visible(el) { return !!el && el.getClientRects().length > 0; }

  /* v4.1: Shrine's StickyHeader (scripts.js) calls classList.add/remove on the
     header section and body on EVERY scroll event; per spec a no-op add/remove
     still rewrites the class attribute, forcing a style recalc and fanning out to
     every MutationObserver on the page (Clarity, Shopify pixel, Kaching,
     rgx-upsell). Shadow add/remove on just those two elements to skip calls whose
     token state already matches. End state is always identical; toggle/replace
     and every other element are untouched. */
  function quietClassList(el) {
    if (!el || el.__rgxQuiet) return;
    el.__rgxQuiet = true;
    var cl = el.classList;
    var oa = DOMTokenList.prototype.add, orm = DOMTokenList.prototype.remove;
    cl.add = function () {
      for (var i = 0; i < arguments.length; i++) if (!cl.contains(arguments[i])) return oa.apply(cl, arguments);
    };
    cl.remove = function () {
      for (var i = 0; i < arguments.length; i++) if (cl.contains(arguments[i])) return orm.apply(cl, arguments);
    };
  }
  function rgxHeaderEl() { return document.querySelector('.shopify-section[id*="__header"]'); }

  function css() {
    if (document.getElementById('rgx-extras-css')) return;
    var s = document.createElement('style');
    s.id = 'rgx-extras-css';
    s.textContent =
      '.article-template__hero-container{display:none !important;}' +
      '#rgx-readbar{position:fixed;top:0;left:0;height:3px;background:#953333;width:0;z-index:10045;pointer-events:none;display:block !important;}' +
      '.rgx-readtime{display:flex !important;width:max-content;align-items:center;gap:.5rem;border:1px dashed #C49A9A;background:#FBF5F5;color:#7D2929;border-radius:6px;padding:.45rem 1rem;font-size:1.2rem;font-weight:600;letter-spacing:.02em;margin:1.2rem 0 .6rem;}' +
      '.rgx-readtime--inline{display:inline-flex !important;width:auto;vertical-align:middle;margin:0 0 0 1.2rem;transform:translateY(-0.12em);}' +
      '.rgx-readtime [class*="material-symbols"]{font-size:1.45rem;}' +
      '#rgx .rgx-title{margin:0;}' +
      '#rgx .rgx-readtime{margin:14px 0;}' +
      '#rgx-sold{display:flex !important;align-items:center;gap:1rem;background:none;padding:0;margin:1.4rem 0 .6rem;}' +
      '#rgx-sold .rgx-sold__track{display:block !important;flex:1 1 auto;min-width:0;height:12px;border-radius:99px;background:rgba(147,51,51,.12);}' +
      '#rgx-sold .rgx-sold__fill{display:block !important;position:relative;width:93%;height:100%;border-radius:99px;background:#f7efdb;border:1px solid #e7d4a8;box-sizing:border-box;box-shadow:0 0 6px 1px rgba(199,166,75,.45);}' +
      '#rgx-sold .rgx-sold__label{display:inline-block !important;color:#7D2929;font-weight:700;font-size:1.3rem;white-space:nowrap;}' +
      '#rgx-sold .rgx-sold__sep{display:inline-block !important;color:rgba(125,41,41,.45);font-weight:700;}' +
      '#rgx-sold .rgx-sold__batch{display:flex !important;align-items:center;gap:.4rem;color:rgba(125,41,41,.75);font-weight:600;font-size:1.2rem;white-space:nowrap;flex:0 0 auto;}' +
      '#rgx-sold .rgx-sold__batch [class*="material-symbols"]{font-size:1.4rem;display:inline-block !important;}' +
      '.product__info-wrapper div:has(> product-form.main-product-form){margin-top:10px !important;}' +
      '.product__info-wrapper .rg-pl__pill{display:inline-flex !important;align-items:center;justify-content:center;text-align:center;}' +
      '@media (max-width:749px){' +
        'html,body{overflow-x:clip;}' +
        '#rgx-sold{flex-wrap:wrap;gap:.6rem .8rem;}' +
        '#rgx-sold .rgx-sold__track{flex-basis:100%;}' +
        '#rgx-sold .rgx-sold__label{font-size:1.35rem;}' +
        '#rgx-sold .rgx-sold__batch{font-size:1.25rem;}' +
        '#rgx-sold .rgx-sold__batch [class*="material-symbols"]{font-size:1.45rem;}' +
        '.rgx-reviews{width:100%;flex-wrap:wrap;border-radius:14px;padding:.85rem 1.3rem;gap:.55rem 1rem;}' +
        '.rgx-reviews__stars{font-size:1.5rem;order:1;}' +
        '.rgx-reviews__avatars{order:2;margin-left:auto;}' +
        '.rgx-reviews__avatars img{width:2.6rem;height:2.6rem;margin-left:-0.8rem;}' +
        '.rgx-reviews__text{order:3;flex-basis:100%;font-size:1.3rem;white-space:normal;}' +
        '.product__info-wrapper .rg-pl{display:flex;align-items:center;flex-wrap:nowrap !important;gap:1rem;min-width:0;max-width:100%;}' +
        '.product__info-wrapper .rg-pl__now{font-size:1.9rem !important;}' +
        '.product__info-wrapper .rg-pl__was{font-size:1.4rem !important;}' +
        '.product__info-wrapper .rg-pl__pill{white-space:normal;flex:1 1 auto !important;min-width:0;font-size:1.35rem !important;line-height:1.3;padding:.5em .8em !important;}' +
        '.product__info-wrapper .rg-deliv8{display:flex !important;align-items:center;justify-content:space-between;flex-wrap:wrap !important;gap:.3rem 1rem;font-size:1.25rem !important;}' +
        '.product__info-wrapper .rg-deliv8 *{font-size:inherit !important;white-space:nowrap;}' +
      '}' +
      '' +
      '.rgx-reviews{display:inline-flex !important;align-items:center;gap:1rem;background:#F7F7F7;border-radius:999px;padding:.65rem 1.5rem .65rem 1.6rem;}' +
      '.rgx-reviews__stars{color:#E8A33D;font-size:1.8rem;letter-spacing:.1em;line-height:1;}' +
      '.rgx-reviews__text{color:#1c1c1c;font-size:1.45rem;font-weight:500;white-space:nowrap;}' +
      '.rgx-reviews__avatars{display:flex !important;}' +
      '.rgx-reviews__avatars img{width:3rem;height:3rem;border-radius:50%;object-fit:cover;border:2px solid #fff;margin-left:-0.85rem;display:block !important;}' +
      '.rgx-reviews__avatars img:first-child{margin-left:0;}';
    document.head.appendChild(s);
  }

  function isArticle() { return /\/blogs\//.test(location.pathname); }

  /* v4.1: ease() + rgxMotion() removed — the 40ms hourglass ticker was the main
     PDP mutation source; the hourglass icon is static now. */

  /* v3.3: fitTo/fitRows removed \u2014 the pill and delivery rows now wrap via CSS,
     which always fits; the shrink-to-fit approach could hit its minimum font size
     and still overflow, widening the document. */

  /* v4.2: the sale pill lives in its OWN .rgx-sale-pills holder, a sibling of
     upsell's .rgx-deal-pills \u2014 upsell rewrites its holder with innerHTML on every
     sync and used to wipe the pill when it shared that node. */
  function cartSalePill() { return;
  }

  function readBar() {
    if (document.getElementById('rgx-readbar')) return;
    var b = document.createElement('div');
    b.id = 'rgx-readbar';
    document.body.appendChild(b);
    deAnim(b);
    function upd() {
      var max = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      var p = Math.min(100, Math.max(0, (window.scrollY / max) * 100));
      b.style.width = p.toFixed(2) + '%';
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    setInterval(upd, 400);
    upd();
  }

  function readTime() {
    if (document.querySelector('.rgx-readtime')) return;
    var body = document.querySelector('.article-template__content, .article-template .rte, article .rte, .rte');
    if (!body) return;
    var words = (body.textContent || '').trim().split(/\s+/).length;
    if (words < 100) return;
    var lo = Math.max(1, Math.round(words / 260));
    var hi = Math.max(lo, Math.round(words / 170));
    var label = lo === hi ? (lo + ' Minute Read') : (lo + '\u2013' + hi + ' Minute Read');
    var h = document.querySelector('#rgx .rgx-title') || document.querySelector('.article-template__title, .article-template h1, article h1, main h1');
    var date = h && h.parentElement ? h.parentElement.querySelector('.circle-divider') : null;
    var p = document.createElement('div');
    p.className = 'rgx-readtime';
    p.innerHTML = '<span class="material-symbols-outlined">schedule</span>Estimated ' + label;
    var anchor = visible(date) ? date : (visible(h) ? h : null);
    if (anchor) anchor.insertAdjacentElement('afterend', p);
    if (!visible(p)) {
      var hh = body.querySelector('h1, h2');
      if (hh) { p.classList.add('rgx-readtime--inline'); hh.appendChild(p); }
      else body.insertBefore(p, body.firstChild);
    }
    deAnim(p);
    setTimeout(function () { deAnim(p); }, 150);
    setTimeout(function () { deAnim(p); }, 600);
  }

  function soldBar() { return; /* v4.4 (2026-07-18): 93% Sold bar removed per Jiwan. Restore by deleting this early return. */
    var existing = document.getElementById('rgx-sold');
    if (existing) return;
    var d = new Date(Date.now() + 14 * 864e5);
    var batch = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    var w = document.createElement('div');
    w.id = 'rgx-sold';
    w.innerHTML =
      '<div class="rgx-sold__track"><div class="rgx-sold__fill" style="width:93%;"></div></div>' +
      '<span class="rgx-sold__label">93% Sold</span>' +
      '<span class="rgx-sold__sep">\u2022</span>' +
      '<div class="rgx-sold__batch"><span class="material-symbols-outlined">hourglass_top</span>Order now or wait until ' + batch + '</div>';
    var placed = false;
    var pill = document.querySelector('.product__info-wrapper .rg-pl__pill');
    var info = document.querySelector('.product__info-wrapper product-info, .product__info-wrapper .product__info-container');
    if (pill && info && info.contains(pill)) {
      var node = pill;
      while (node.parentElement && node.parentElement !== info) node = node.parentElement;
      if (node.parentElement === info) { info.insertBefore(w, node); placed = true; }
    }
    if (!placed) {
      var anchor = document.querySelector('.product__info-wrapper .rg-bengrid') || document.querySelector('.product__info-wrapper .rg-pills');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', w);
    }
    deAnim(w);
    setTimeout(function () { deAnim(w); }, 150);
    setTimeout(function () { deAnim(w); }, 600);
    setTimeout(function () { deAnim(w); }, 1500);
  }

  function reviewsPill(){}

  /* The drawer totals row gets periodically re-rendered (OCU cart widget / theme
     cart refresh), which wiped the sale pill; this observer re-injects in the
     SAME mutation batch, before paint, so the pill is never visibly absent.
     cartSalePill's id guard makes the observer's own feedback a no-op.
     v4.2: records from the reservation timer and the pill holders are ignored so
     routine ticks / pill writes can't wake this observer at all. */
  var pillWatched = null;
  var PILL_IGNORE = '.cart-timer, .rgx-sale-pills, .rgx-deal-pills';
  function watchDrawerPill() {
    var dr = document.querySelector('cart-drawer');
    if (!dr) return;
    if (dr === pillWatched && document.contains(dr)) return;
    pillWatched = dr;
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          var el = t.nodeType === 1 ? t : t.parentElement;
          if (el && el.closest && el.closest(PILL_IGNORE)) continue;
          cartSalePill();
          return;
        }
      }).observe(dr, { childList: true, subtree: true });
    } catch (e) {}
    cartSalePill();
  }

  function init() {
    /* v3.4: always open at the top. Safari restores the previous scroll position
       on reload / tab restore; scrollRestoration=manual disables that, and the
       pageshow pin also covers back-forward-cache restores. Anchor links exempt. */
    /* rgx: scrollRestoration left as browser default (auto) */
    function toTop() { if (!location.hash) window.scrollTo(0, 0); }
    /* Only pin on back-forward-cache restores (persisted). The initial pageshow
       fires at window load \u2014 after the person may already be scrolling \u2014 and
       pinning there yanked them back to the top once per visit. */
    /* rgx: auto-scroll-to-top on load/bfcache removed per request */
    css();
    quietClassList(document.body);
    quietClassList(rgxHeaderEl());
    if (isArticle()) { readBar(); readTime(); setInterval(readTime, 900); }
    if (/\/products\//.test(location.pathname)) {
      soldBar(); reviewsPill();
      setInterval(function () { soldBar(); reviewsPill(); }, 900);
    }
    watchDrawerPill();
    setInterval(function () { watchDrawerPill(); cartSalePill(); quietClassList(rgxHeaderEl()); }, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* rg 2026-08-19 - header rule colour flip.
   Resilia's rule turns brand-coloured the moment their ticker starts sliding under
   the pinned header. Their promo bar is 60px and sticky at top 0 while the header is
   58.5px and also sticky at top 0, so once the header pins a 1.5px sliver of the
   promo bar's green shows below it. There is no promo bar above our header, so our
   ticker starts going under as soon as the page moves at all - hence scrollY > 0.
   Dawn's own .scrolled-past-header fires ~90-200px in, far too late for this.
   Remove this block and the .rg-scrolled rules in regenis-clone.css to revert. */
(function () {
  var root = document.documentElement;
  var on = false;
  function sync() {
    var next = (window.scrollY || window.pageYOffset || 0) > 0;
    if (next !== on) { on = next; root.classList.toggle('rg-scrolled', on); }
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { sync(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  sync();
})();

/* rg 2026-08-19 - bundle-aware gallery hero.

   Kaching's own "Featured image" setting publishes fine but is a NO-OP on this
   theme: verified on the live PDP that the gallery's active slide never changes
   and no error is thrown. That is the "works with most themes" caveat in their
   dialog. This does the swap with the theme's own media-gallery API instead.

   Resilia shows exactly ONE bundle hero at a time - the strip never carries both.
   Since the heroes have to live in the product gallery for the lookup to work,
   the inactive one is hidden (slide + thumbnail) rather than left browsable.

   Matching is by FILENAME, not media id, so re-uploading the art keeps working as
   long as the files stay named rg-bundle-buy2 / rg-bundle-buy3. */
(function () {
  var TOKENS = ['rg-bundle-buy2', 'rg-bundle-buy3'];
  var MAP = { 1: 'rg-bundle-buy2', 2: 'rg-bundle-buy3' };   // keyed by bar index
  var SELS = ['.product__media-item', '.thumbnail-list__item'];
  var last = null;

  function srcOf(el) {
    var img = el.querySelector('img');
    if (!img) return '';
    return img.currentSrc || img.src || img.getAttribute('data-src') || '';
  }

  function showOnly(active) {
    for (var t = 0; t < TOKENS.length; t++) {
      var token = TOKENS[t];
      var visible = (token === active);
      for (var s = 0; s < SELS.length; s++) {
        var els = document.querySelectorAll(SELS[s]);
        for (var i = 0; i < els.length; i++) {
          if (srcOf(els[i]).indexOf(token) !== -1) {
            els[i].style.display = visible ? '' : 'none';
          }
        }
      }
    }
  }

  function mediaIdFor(token) {
    var items = document.querySelectorAll('.product__media-item[data-media-id]');
    for (var i = 0; i < items.length; i++) {
      if (srcOf(items[i]).indexOf(token) !== -1) {
        var id = items[i].getAttribute('data-media-id');
        if (id && id.indexOf('__main-') !== -1) return id;
      }
    }
    return null;
  }

  /* the first slide that is NOT a bundle hero. Derived every time rather than captured
     at boot, because by the time this first runs a hero may already be prepended. */
  function defaultMediaId() {
    var items = document.querySelectorAll('.product__media-item[data-media-id*="__main-"]');
    for (var i = 0; i < items.length; i++) {
      var s = srcOf(items[i]);
      if (s && s.indexOf('rg-bundle-buy') === -1) return items[i].getAttribute('data-media-id');
    }
    return null;
  }

  function sync() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return;
    var idx = -1;
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].className.indexOf('--selected') !== -1) idx = i;
    }
    if (idx < 0 || idx === last) return;
    last = idx;

    var g = document.querySelector('media-gallery');
    if (!g || typeof g.setActiveMedia !== 'function') return;

    var token = MAP[idx] || null;
    showOnly(token);                                  // hide whichever hero is not in play
    var id = token ? mediaIdFor(token) : defaultMediaId();   // Buy One falls back to the product default
    if (!id) return;
    try { g.setActiveMedia(id, true); } catch (e) {}
  }

  function boot() {
    sync();
    var host = document.querySelector('.kaching-bundles') || document.body;
    new MutationObserver(sync).observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function () { setTimeout(sync, 250); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* rg 2026-08-19 - Add-to-cart + delivery row restyled to resilia.shop.

   Their button markup, lifted from their DOM:
     .add-to-cart-button.atc-redesign
       .atcr-label            "Add to Cart"
       .atcr-pill             pill: compare price, price, divider, guarantee
       .atcr-arrow            arrow glyph
   Ours already renders the same pieces (.rg-atc__cmp / .rg-atc__pr / .rg-atc-sub),
   and the theme rewrites those nodes IN PLACE on bundle change (verified: the same
   node object survives every switch). So this only has to reparent them ONCE - no
   polling, no observer, and the prices stay live for free. */
(function () {
  function build() {
    var main = document.querySelector('.rg-atc-main');
    if (!main || main.dataset.atcr === '1') return;
    var row = main.querySelector('.rg-atc-row');
    var pr  = main.querySelector('.rg-atc__pr');
    var cmp = main.querySelector('.rg-atc__cmp');
    if (!row || !pr) return;

    // wrap the bare "Add To Cart" text node so it can be laid out on its own
    var label = document.createElement('span');
    label.className = 'atcr-label';
    for (var i = 0; i < row.childNodes.length; i++) {
      var n = row.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { label.textContent = n.textContent.trim(); n.textContent = ''; break; }
    }
    if (!label.textContent) label.textContent = 'Add To Cart';

    var pill = document.createElement('span');
    pill.className = 'atcr-pill';
    if (cmp) pill.appendChild(cmp);      // compare first, like theirs
    pill.appendChild(pr);

    var div = document.createElement('span');
    div.className = 'atcr-divider';
    div.setAttribute('aria-hidden', 'true');
    pill.appendChild(div);

    var g = document.createElement('span');
    g.className = 'atcr-guarantee';
    g.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"></circle>' +
      '<path d="M8.4 12.2l2.4 2.4 4.8-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg><span>90-Day Guarantee</span>';
    pill.appendChild(g);

    var arrow = document.createElement('span');
    arrow.className = 'atcr-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<svg width="22" height="14" viewBox="0 0 24 16" fill="none">' +
      '<path d="M2 8h18M15 2l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    row.insertBefore(label, row.firstChild);
    row.appendChild(pill);
    row.appendChild(arrow);
    main.dataset.atcr = '1';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  // the theme can re-render the button once on load; one cheap retry covers it
  setTimeout(build, 1200);
})();
